import { Box, Flex, Text } from '@chakra-ui/react';
import InformationSourcePopup from '@src/modules/performance/components/InformationSourcePopup';

function ReportHeader({
  children, title, subtitle, informationSource, ...rest
}) {
  return (
    <Flex
      width="100%"
      background="white"
      boxShadow="base"
      borderRadius="base"
      px={4}
      py={4}
      position="sticky"
      zIndex="200"
      top="130px"
      justify="space-between"
      align="center"
      className="report-header"
      mb={2}
      {...rest}
    >
      <Box>
        <Flex align="center">
          <Text fontWeight="bold" fontSize="2xl" mr={1} className="report-title">{title}</Text>
          {informationSource && (
            <InformationSourcePopup
              title={informationSource.title}
              content={informationSource.content}
              source={informationSource.source}
            />
          )}
        </Flex>
        <Text fontWeight="bold" color="gray" className="report-subtitle">{subtitle}</Text>
      </Box>
      {children}
    </Flex>
  );
}

export default ReportHeader;
